import React, { Component } from "react";
export default class AlspsychosisSection extends Component {
  render() {
    var {
      name,
      als_psychosis_q1_status,
      als_psychosis_q1_description,
      als_psychosis_q2_status,
      als_psychosis_q2_description,
      als_psychosis_q3_status,
      als_psychosis_q3_description,
      als_psychosis_score,
      onset_duration_symtom_q1_status,
      onset_duration_symtom_q2_status,
      onset_duration_symtom_q3_status,
      onset_duration_symtom_q4_status,
      onset_duration_symtom_q5_status,
    } = this.props.data;
    return (
      <table className="fs-19 table-black w-100 border border-dark text-right">
        <tbody>
          <tr>
            <td
              className="text-left"
              style={{
                paddingLeft: 50,
                paddingTop: 20,
              }}
              colSpan="6"
            >
              Please ask the caregiver about the following possible symptoms.
              Check ‘Yes’, ‘No’ or ‘Don’t Know’. If ‘Yes’, please provide a
              brief description.
              <ul
                style={{
                  paddingLeft: 20,
                  fontSize: 19,
                }}
              >
                <li
                  style={{
                    listStyle: "square",
                  }}
                >
                  Guidance:
                  <ul
                    style={{
                      paddingLeft: 40,
                    }}
                  >
                    <li
                      style={{
                        listStyle: "circle",
                      }}
                    >
                      Please complete this interview with the carer or relative
                      in private from the patient, ideally in a separate room.
                    </li>
                    <li
                      style={{
                        listStyle: "circle",
                      }}
                    >
                      Please remind the carer or relative that the questions
                      asked are only relevant since the onset of ALS.
                    </li>
                  </ul>
                </li>
                <li
                  style={{
                    listStyle: "square",
                  }}
                >
                  Administration :
                  <ul
                    style={{
                      paddingLeft: 40,
                    }}
                  >
                    <li
                      style={{
                        listStyle: "circle",
                      }}
                    >
                      Please ask the carer about the following possible
                      symptoms. Tick ‘Yes’, ‘No’ or ‘Don’t Know’. If ‘Yes’,
                      please provide a brief description. Scoring: Give one mark
                      for every ‘Yes’ response (range = 0-3).
                    </li>
                  </ul>
                </li>
                <li
                  style={{
                    listStyle: "square",
                  }}
                >
                  Say:
                  <ul
                    style={{
                      paddingLeft: 40,
                    }}
                  >
                    <li
                      style={{
                        listStyle: "circle",
                      }}
                    >
                      Please answer the following questions as honestly as you
                      can. The questions are directly correlated with any
                      behavior since the onset of ALS.
                    </li>
                  </ul>
                </li>
                <li
                  style={{
                    listStyle: "square",
                  }}
                >
                  Say:
                  <ul
                    style={{
                      paddingLeft: 40,
                    }}
                  >
                    <li
                      style={{
                        listStyle: "circle",
                      }}
                    >
                      Please answer the following questions as honestly as you
                      can. The questions are directly correlated with any
                      behavior since the onset of ALS.
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td className="text-align-center">1</td>
            <td className="text-left" style={{ maxWidth: 250 }}>
              Does {name ? name : "***"} have any strange and/or bizarre beliefs
              and behaviors?
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  als_psychosis_q1_status == "1" ? "button active" : "button"
                }
              >
                Y
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  als_psychosis_q1_status == "N" ? "button active" : "button"
                }
              >
                N
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  als_psychosis_q1_status == "DK" ? "button active" : "button"
                }
              >
                DK
              </button>
            </td>
            <td style={{ width: 80 }}>
              <input
                type="number"
                className="ecas-input-field"
                placeholder="Score"
                disabled
                value={als_psychosis_q1_status == true ? 1 : 0}
                style={{
                  width: "92%",
                  marginRight: 14,
                  marginBottom: 10,
                }}
              />
            </td>
          </tr>
          {als_psychosis_q1_status == true && (
            <tr>
              <td colSpan="2"></td>
              <td colSpan="3">
                <textarea
                  style={{
                    width: "93%",
                    margin: "5px 12px 5px 0",
                    fontSize: 15,
                  }}
                  name="als_psychosis_q1_description"
                  value={als_psychosis_q1_description}
                  placeholder="Description.."
                  id=""
                  cols="1"
                  rows="2"
                ></textarea>
              </td>
            </tr>
          )}
          <tr>
            <td className="text-align-center">2</td>
            <td className="text-left" style={{ maxWidth: 250 }}>
              Does {name ? name : "***"} ever claim to hear, see things that are
              not there, and/or feel the presence of someone who is not there?
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  als_psychosis_q2_status == "1" ? "button active" : "button"
                }
              >
                Y
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  als_psychosis_q2_status == "N" ? "button active" : "button"
                }
              >
                N
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  als_psychosis_q2_status == "DK" ? "button active" : "button"
                }
              >
                DK
              </button>
            </td>
            <td style={{ width: 80 }}>
              <input
                type="number"
                className="ecas-input-field"
                placeholder="Score"
                disabled=""
                value={als_psychosis_q2_status == true ? 1 : 0}
                style={{
                  width: "92%",
                  marginRight: 14,
                  marginBottom: 10,
                }}
              />
            </td>
          </tr>
          {als_psychosis_q2_status == true && (
            <tr>
              <td colSpan="2"></td>
              <td colSpan="3">
                <textarea
                  style={{
                    width: "93%",
                    margin: "5px 12px 5px 0",
                    fontSize: 15,
                  }}
                  name="als_psychosis_q2_description"
                  value={als_psychosis_q2_description}
                  placeholder="Description.."
                  id=""
                  cols="1"
                  rows="2"
                ></textarea>
              </td>
            </tr>
          )}
          <tr>
            <td className="text-align-center">3</td>
            <td className="text-left" style={{ maxWidth: 250 }}>
              Is {name ? name : "***"} ever overly suspicious, and/or feels
              persecuted?
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  als_psychosis_q3_status == "1" ? "button active" : "button"
                }
              >
                Y
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  als_psychosis_q3_status == "N" ? "button active" : "button"
                }
              >
                N
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  als_psychosis_q3_status == "DK" ? "button active" : "button"
                }
              >
                DK
              </button>
            </td>
            <td style={{ width: 80 }}>
              <input
                type="number"
                className="ecas-input-field"
                placeholder="Score"
                disabled=""
                value={als_psychosis_q3_status == true ? 1 : 0}
                style={{
                  width: "92%",
                  marginRight: 14,
                  marginBottom: 10,
                }}
              />
            </td>
          </tr>
          {als_psychosis_q3_status == true && (
            <tr>
              <td colSpan="2"></td>
              <td colSpan="3">
                <textarea
                  style={{
                    width: "93%",
                    margin: "5px 12px 5px 0",
                    fontSize: 15,
                  }}
                  name="als_psychosis_q3_description"
                  value={als_psychosis_q3_description}
                  placeholder="Description.."
                  id=""
                  cols="1"
                  rows="2"
                ></textarea>
              </td>
            </tr>
          )}
          <tr className="light-grey">
            <td className="text-left" colSpan="5" style={{ paddingLeft: 50 }}>
              <b>SCORE</b>
            </td>
          </tr>
          <tr>
            <td className="text-right pr-3" colSpan="4">
              TOTAL
            </td>
            <td className="text-align-center" colSpan="4">
              <b>
                {als_psychosis_score}
                /3
              </b>
            </td>
          </tr>
          <tr className="light-grey">
            <td className="text-left" colSpan="5" style={{ paddingLeft: 50 }}>
              <b>ONSET AND DURATION OF SYMPTOMS</b>
            </td>
          </tr>
          <tr>
            <td className="text-left" colSpan="5" style={{ paddingLeft: 50 }}>
              Please tick or complete box to indicate response.
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan="3"
              style={{
                maxWidth: 250,
                fontSize: 16,
              }}
            >
              <b>
                {" "}
                1. Do these symptoms represent a CHANGE from the patient’s
                previous behaviour?
              </b>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q1_status == "1"
                    ? "button active"
                    : "button"
                }
              >
                Y
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q1_status == "0"
                    ? "button active"
                    : "button"
                }
              >
                N
              </button>
            </td>
            <td>
              <input
                type="number"
                className="ecas-input-field"
                placeholder="Score"
                disabled=""
                value={onset_duration_symtom_q1_status == true ? 1 : 0}
                style={{
                  width: "92%",
                  marginRight: 14,
                  marginBottom: 10,
                }}
              />
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan="5"
              style={{
                maxWidth: 250,
                fontSize: 16,
              }}
            >
              If yes, did the changes occur:
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan="3"
              style={{
                maxWidth: 250,
                fontSize: 16,
              }}
            >
              a. BEFORE the onset of the disease?
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q2_status == "1"
                    ? "button active"
                    : "button"
                }
              >
                Y
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q2_status == "N"
                    ? "button active"
                    : "button"
                }
              >
                N
              </button>
            </td>
            <td>
              <input
                type="number"
                className="ecas-input-field"
                placeholder="Score"
                disabled=""
                value={onset_duration_symtom_q2_status == true ? 1 : 0}
                style={{
                  width: "92%",
                  marginRight: 14,
                  marginBottom: 10,
                }}
              />
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan="3"
              style={{
                maxWidth: 250,
                fontSize: 16,
              }}
            >
              b. at the same time as other symptoms?
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q3_status == "1"
                    ? "button active"
                    : "button"
                }
              >
                Y
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q3_status == "N"
                    ? "button active"
                    : "button"
                }
              >
                N
              </button>
            </td>
            <td>
              <input
                type="number"
                className="ecas-input-field"
                placeholder="Score"
                disabled=""
                value={onset_duration_symtom_q3_status == true ? 1 : 0}
                style={{
                  width: "92%",
                  marginRight: 14,
                  marginBottom: 10,
                }}
              />
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan="3"
              style={{
                maxWidth: 250,
                fontSize: 16,
              }}
            >
              c. AFTER the onset of the disease?
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q4_status == "1"
                    ? "button active"
                    : "button"
                }
              >
                Y
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q4_status == "N"
                    ? "button active"
                    : "button"
                }
              >
                N
              </button>
            </td>
            <td>
              <input
                type="number"
                className="ecas-input-field"
                placeholder="Score"
                disabled=""
                value={onset_duration_symtom_q4_status == true ? 1 : 0}
                style={{
                  width: "92%",
                  marginRight: 14,
                  marginBottom: 10,
                }}
              />
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan="3"
              style={{
                maxWidth: 250,
                fontSize: 16,
              }}
            >
              <b>2. Do they still persist?</b>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q5_status == "1"
                    ? "button active"
                    : "button"
                }
              >
                Y
              </button>
            </td>
            <td className="pl-0 text-align-center">
              <button
                className={
                  onset_duration_symtom_q5_status == "N"
                    ? "button active"
                    : "button"
                }
              >
                N
              </button>
            </td>
            <td>
              <input
                type="number"
                className="ecas-input-field"
                placeholder="Score"
                disabled=""
                value={onset_duration_symtom_q5_status == true ? 1 : 0}
                style={{
                  width: "92%",
                  marginRight: 14,
                  marginBottom: 10,
                }}
              />
            </td>
          </tr>
          <tr>
            <td
              className="text-left"
              colSpan="5"
              style={{
                maxWidth: 250,
                fontSize: 16,
              }}
            >
              <b>3. If not, how long did they last?</b>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
